export default __webpack_public_path__ + "static/media/github-icon.5ce107cc.svg";